import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';
import { PCXKeyValue } from '../models/domain/PCXKeyValue';

@Pipe({
    name: 'translateLabel',
    standalone: false
})
export class TranslateLabelPipe implements PipeTransform {
    constructor(private commonService: CommonService) {}
    transform(label: PCXKeyValue[], languageKey: string | null = null): string {
        if (label === null || label.length === 0) {
            return '';
        }

        if (languageKey === null) {
            languageKey = this.commonService.getCurrentLanguageKey();
        } else {
            languageKey = CommonService.getLanguageKeyFromLang(languageKey);
        }

        const selectedLabel = label.filter(x => x.Key === languageKey);
        return selectedLabel[0]?.Value ?? '';
    }
}
